// extracted by mini-css-extract-plugin
export var hidden = "_sb-0";